import { jsx as _jsx } from "react/jsx-runtime";
import { XingFrameContext } from '@xingternal/hub';
export const XingFrameConsumer = XingFrameContext.Consumer;
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const xingConnect = (mapStateToProps = (state, ownProps) => ({ ...state, ...ownProps })) => (WrappedComponent) => {
    const Wrapper = (props) => (_jsx(XingFrameConsumer, { children: (state) => (_jsx(WrappedComponent, { ...mapStateToProps(state !== null && state !== void 0 ? state : {}, props), ...props })) }));
    Wrapper.displayName = `xingConnect(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return Wrapper;
};
export { xingConnect };
//# sourceMappingURL=xing-connect.js.map